// extracted by mini-css-extract-plugin
export default {"Box":"access-settings-view-module__Box--hH08t","Heading":"access-settings-view-module__Heading--GLonW"};